import { parse } from "json5";
import ky from "ky";

import { dataFileUrls } from "../../urls";

import { parseNewsArray } from "./structs";

/**
 * お知らせを返す。
 *
 * @returns お知らせデータの配列
 */
export const getNews = async () => {
    const json5Text = await ky
        .get(dataFileUrls["/news/news.json"].get(), { cache: "no-cache" })
        .text();

    const json = parse(json5Text);

    // ApiResponseの構造ではないため`assertApiResponse`の確認は不要

    return parseNewsArray(json);
};
